import { type ReactNode, createContext } from 'react';
import { useTeaEditor } from '../../hooks/use-tea-editor.ts';
import { AlignmentControl } from './alignment-control.tsx';
import { InsertControl } from './insert-control.tsx';
import { ScriptControl } from './script-control.tsx';

export const TeaClientContext = createContext<
  ReturnType<typeof useTeaEditor> | Record<string, never>
>({});

export function TeaEditorControls({
  id,
  children,
}: { id: string; children: ReactNode }) {
  const listener = useTeaEditor(id);

  return (
    <TeaClientContext.Provider value={listener}>
      {children}
    </TeaClientContext.Provider>
  );
}

TeaEditorControls.Alignment = AlignmentControl;
TeaEditorControls.Script = ScriptControl;
TeaEditorControls.Insert = InsertControl;
